export interface LabelValueOption {
  value: string;
  label: string;
}

export function isLabelValueOption(value: unknown): value is LabelValueOption {
  return (
    typeof value === 'object' &&
    value !== null &&
    'value' in value &&
    'label' in value &&
    (typeof (value as LabelValueOption).value === 'string' ||
      typeof (value as LabelValueOption).label === 'string')
  );
}

export function getLabelValueText(value: unknown, fallback = ''): string {
  if (value == null) {
    return fallback;
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (isLabelValueOption(value)) {
    if (typeof value.label === 'string' && value.label.trim()) {
      return value.label;
    }

    if (typeof value.value === 'string' && value.value.trim()) {
      return value.value;
    }
  }

  return fallback;
}
